import type { SVGProps } from 'react';
const SvgFlipBackward = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2 6h9a3 3 0 1 1 0 6H8M2 6l2.667-2.666M2 6.001l2.667 2.666"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);
export default SvgFlipBackward;
export { SvgFlipBackward };
